

<div class="grey-bg">
    <div class="max-page-width">
        <div class="text-center OurStatistics">
            <h2>{{ 'OurStatistics' | translate }}</h2>
        </div>
        <div class="counters text-center" id="statistic_div" #statisticDiv>
            <div class="row" *ngIf="statistic!=null">
                <div class="col-md-4 col-12 d-flex justify-content-center align-items-center counters-section">
                    <fa-icon class="float-left" [icon]="faCar"></fa-icon>
                    <div class="text-left wow zoomIn">
                        <span class="text-blue">{{statistic.vehicles}}</span>
                        <p class="mb-0">{{ 'RentalCars' | translate }}</p>
                    </div>
                </div>
                <div class="col-md-4 col-12 d-flex justify-content-center align-items-center counters-section">
                    <fa-icon  class="float-left" [icon]="faExchangeAlt"></fa-icon>
                    <div class="text-left wow zoomIn">
                        <span class="text-blue">{{statistic.vehicleReservationCases}}</span>
                        <p class="mb-0">{{ 'SuccessfulBookings' | translate }}</p>
                    </div>
                </div>
                <div class="col-md-4 col-12 d-flex justify-content-center align-items-center counters-section">
                    <fa-icon  class="float-left" [icon]="faRestroom"></fa-icon>
                    <div class="text-left wow zoomIn">
                        <span class="text-blue">{{statistic.customers}}</span>
                        <p class="mb-0">{{ 'RegisteredCustomers' | translate }}</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
